import llStorage from '../llStorage';
import { clearGatesFromStorage } from './planGating';

export function logout() {
  // Remove token or any auth data using llStorage
  llStorage.removeItem('token');
  // Optionally, remove other user data if needed
  llStorage.removeItem('refreshToken');
  llStorage.removeItem('userImage');
  llStorage.removeItem('userName');
  llStorage.removeItem('userId');
  llStorage.removeItem('keepLoggedIn');
  llStorage.removeItem('userPlanSubscription');
  llStorage.removeItem('userPlanSubscriptionStatus');
  llStorage.removeItem('showHiddenFeatures');
  llStorage.removeItem('goodnessSponsor');
  // Clear plan gates from storage
  clearGatesFromStorage();
  // Redirect to the login page
  window.location.href = '/login';
  // If you use a navigate function from react-router-dom, you can use that instead:
  navigate('/login');
}

// Decode JWT token and schedule logout
export function scheduleAutoLogout() {
  const token = llStorage.getItem('refreshToken') || llStorage.getItem('token');
  if (!token) return;
  try {
    // Decode payload (this assumes a standard JWT structure)
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const payload = JSON.parse(decodeURIComponent(escape(window.atob(base64))));
    // exp is typically in seconds since epoch
    const expirationTime = payload.exp * 1000;
    const delay = expirationTime - Date.now();
    if (delay > 0) {
      setTimeout(() => {
        logout();
      }, delay);
    } else {
      // If already expired
      logout();
    }
  } catch (error) {
    console.error('Error decoding token', error);
    logout();
  }
}